export type LoadingStatus = 'sleeping' | 'awakening' | 'awake' | 'dead';

export const SLEEPING = { status: 'sleeping' };

export function createLazy<T>(): Lazy<T> {
  return SLEEPING as Lazy<T>;
}

export interface Lazy<T> {
  status: LoadingStatus;
  item?: T;
}
